export default __webpack_public_path__ + "static/media/Fourteen.71abc522.svg";